var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"5480ce4154a7edb8252e0c7da30d45d2c6ceb4df"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["nextjs@floppylabs"]={id:"5480ce4154a7edb8252e0c7da30d45d2c6ceb4df"};
      